import { reactify } from '@zeiss/zui-react';
export const ZuiIconFilesFolderMoveToFolder = reactify('zui-icon-files-folder-move-to-folder');
